<template>
  <div class="widget-table">
    <div class="card">
      <div class="card-header"><h5>Avui  {{ new Date().toLocaleDateString() }}</h5></div>

      <span class="badge badge-primary rounded-0" style="text-align:left; padding:15px 20px; font-size:15px; background-color:#0073CF"><strong v-if="reverse">Sortides Trens</strong><strong v-else> Arribades Trens</strong> </span> 

      <div class="card-body">
        <div v-for="(item, index) in data" :key="index">
        <div class="widget-box">
          <div v-if="reverse">
            <table class="table table-sm" style="line-height: 1em;">
              <tr>
                <th>Hora</th>
                <th>Destí</th>
                <th>Tipus</th>
              </tr>
              <tr v-for="(item, index) in item['vars'][ rootData]" :key="index">
                <td>{{ item[0] }}</td>
                <td>{{ item[1] }}</td>
                <td>{{ item[2] }}</td>
              </tr>
            </table>
          </div> 
          <div v-else>
            <table class="table table-sm" style="line-height: 1em;">
              <tr>
                <th>Procedent</th>
                <th>Hora</th>
                <th>Tipus</th>
              </tr>
              <tr v-for="(item, index) in item['vars'][rootData]" :key="index">
                <td>{{ item[0] }}</td>
                <td>{{ item[1] }}</td>
                <td>{{ item[2] }}</td>
              </tr>
            </table>
          </div> 
        </div>
      </div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'Table',
  props: {
    rootData: String,
    reverse: String,
    data: Array,
    urlsData: Array
  }
}
</script>
